document.addEventListener('DOMContentLoaded', function() {
    const parallaxSections = document.querySelectorAll('[data-parallax-section]');
    
    // Store breakpoints for each section
    const sectionBreakpoints = [];
    
    // Initialize sections and calculate breakpoints
    parallaxSections.forEach((parallaxSection, index) => {
        const previousSection = parallaxSection.parentElement.previousElementSibling;
        const nextSection = parallaxSection.parentElement.nextElementSibling;
        
        if (!previousSection || !nextSection) return;
        
        // Calculate initial breakpoints
        const breakpoint = {
            section: previousSection,
            parallaxSection: parallaxSection,
            nextSection: nextSection,
            // Point where previous section should become fixed
            fixPoint: previousSection.offsetTop,
            // Point where previous section should start moving up (collision with next)
            releasePoint: null, // Will be calculated during scroll
            // Height of the previous section (used for margin compensation)
            height: previousSection.offsetHeight,
            // Current state: 'normal', 'fixed', or 'releasing'
            state: 'normal',
            // Z-index for proper stacking
            zIndex: 10 + index,
            // True once the section has been pinned via a genuine downward scroll.
            // Until then, page-load scroll restoration must not force top: 0
            // (which would place the section over the nav).
            hasBeenFixed: false
        };
        
        sectionBreakpoints.push(breakpoint);
        
        // Set initial z-index for proper stacking
        parallaxSection.style.position = 'relative';
        parallaxSection.style.zIndex = `${15 + index}`;
        
        // Ensure previous section starts in normal state
        previousSection.style.position = '';
        previousSection.style.top = '';
        previousSection.style.width = '';
        previousSection.style.zIndex = '';
        parallaxSection.style.marginTop = '0';
    });
    
    // Track scroll direction
    let lastScrollY = window.scrollY;
    let scrollDirection = 'down';
    
    function handleScroll() {
        const currentScrollY = window.scrollY;
        scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';
        
        // Update breakpoints and apply effects
        sectionBreakpoints.forEach(bp => {
            const sectionRect = bp.section.getBoundingClientRect();
            const nextSectionRect = bp.nextSection.getBoundingClientRect();
            
            // Calculate the release point if not set
            if (bp.releasePoint === null) {
                // The release point is when the bottom of previous section would hit top of next section
                bp.releasePoint = bp.nextSection.offsetTop - bp.height;
            }
            
            // Determine the current state based on scroll position
            let newState = 'normal';
            
            // Only apply fixed/releasing states if we've scrolled past the fix point
            if (currentScrollY >= bp.fixPoint && currentScrollY < bp.releasePoint) {
                newState = 'fixed';
            } else if (currentScrollY >= bp.releasePoint) {
                newState = 'releasing';
            }
            
            // Apply styles based on state and scroll direction
            if (newState === 'normal') {
                // Normal flow - reset all styles
                bp.section.style.position = '';
                bp.section.style.top = '';
                bp.section.style.width = '';
                bp.section.style.zIndex = '';
                bp.parallaxSection.style.marginTop = '0';
            } 
            else if (newState === 'fixed') {
                if (scrollDirection === 'down') {
                    bp.hasBeenFixed = true;
                }
                bp.section.style.position = 'fixed';
                // Until a genuine downward scroll has activated this section, keep it
                // at its natural document-relative position (negative = above the
                // viewport, invisible) so it cannot cover the nav on scroll restoration.
                bp.section.style.top = bp.hasBeenFixed ? '0' : `${bp.fixPoint - currentScrollY}px`;
                bp.section.style.width = '100%';
                bp.section.style.zIndex = bp.zIndex.toString();
                bp.parallaxSection.style.marginTop = `${bp.height}px`;
            } 
            else if (newState === 'releasing') {
                // Calculate position relative to next section
                const offset = currentScrollY - bp.releasePoint;
                const topPosition = -offset;
                
                bp.section.style.position = 'fixed';
                bp.section.style.top = `${topPosition}px`;
                bp.section.style.width = '100%';
                bp.section.style.zIndex = bp.zIndex.toString();
                bp.parallaxSection.style.marginTop = `${bp.height}px`;
            }
            
            // Update state
            bp.state = newState;
        });
        
        lastScrollY = currentScrollY;
    }
    
    // Fade in images when they enter viewport
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
            }
        });
    }, {
        threshold: 0.1
    });
    
    parallaxSections.forEach(section => {
        section.querySelectorAll('.image-item').forEach(item => {
            observer.observe(item);
        });
    });
    
    window.addEventListener('scroll', () => {
        requestAnimationFrame(handleScroll);
    });
    
    // Calculate all release points before initial call
    sectionBreakpoints.forEach(bp => {
        if (bp.releasePoint === null) {
            bp.releasePoint = bp.nextSection.offsetTop - bp.height;
        }
    });
    
    // Initial call to set correct state on page load
    handleScroll();
    
    // Force a recalculation after a short delay to handle any layout shifts
    setTimeout(() => {
        // Recalculate fix and release points
        sectionBreakpoints.forEach(bp => {
            bp.fixPoint = bp.section.offsetTop;
            bp.releasePoint = bp.nextSection.offsetTop - bp.height;
        });
        handleScroll();
    }, 100);
});
